import {
  Component,
  ContentChildren,
  QueryList,
  Input,
  Output,
  EventEmitter,
  AfterContentInit,
} from "@angular/core";
import { SegmentButtonComponent } from "./segment-button.component";

@Component({
  selector: "icn-segment",
  template: "<ng-content></ng-content>",
  styleUrls: ["./segment.component.scss"],
})
export class SegmentComponent implements AfterContentInit {
  @ContentChildren(SegmentButtonComponent)
  items: QueryList<SegmentButtonComponent>;

  @Input()
  value: any;

  @Input()
  canChangeToNull: boolean;

  @Output()
  valueChange = new EventEmitter<any>();

  ngAfterContentInit() {
    let self = this;
    this.items.forEach((segmentButton) => {
      segmentButton.active = segmentButton.value === self.value;
      segmentButton.icnClick.subscribe((btn: SegmentButtonComponent) => {
        if (btn.active && self.canChangeToNull) {
          self.value = null;
          self.valueChange.emit(null);
          btn.active = false;
        } else {
          if (btn.active) {
            return;
          }
          self.value = btn.value;
          self.valueChange.emit(btn.value);
          self.items.forEach((button) => {
            button.active = false;
          });
          btn.active = true;
        }
      });
    });
  }
}
